<template>
  <div class="plat_role_wrap">
    <div class="left_box">
      <div class="plat_role_title">平台角色</div>
      <div class="plat_role_box" :style="`height: ${windowHeight - 140}px;`">
        <el-menu :default-active="currentRole" class="el-menu-vertical-demo" @select="changeMenu">
          <el-menu-item :index="item.id.toString()" :key="item.id" v-for="item in allRoleList">
            <span slot="title">{{item.name}}</span>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
    <div class="right_box">
      <div class="header">
        <address-book v-model="addressData" :config="configData" :isbutton="true" v-if="isShowByPermission('/wyms/platformRole/insertRoleUser') && constantId !== 10020 && constantId !== 10022">添加用户</address-book>&nbsp;
      </div>
      <div class="plat_role_content">
        <el-table border :height="windowHeight - 160" :data="dataList" style="width: 100%">
          <el-table-column align="center" prop="name" label="姓名" show-overflow-tooltip></el-table-column>
          <el-table-column align="center" label="性别">
            <template slot-scope="scope">
              <span>{{sexList[scope.row.gender] || '--'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="所属经销商" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.bussinessName || '--'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="手机号" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.mobile}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180" v-if="currentRole != 370 && currentRole != 252">
            <template slot-scope="scope">
              <el-button type="text" @click="deleteHandler(scope.row.userId)" v-if="isShowByPermission('/wyms/platformRole/deleteByRoleIdAndUserId')">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
    import {isShowByPermission} from "@/utils/utils";

    import windowResize from '@/mixins/windowResize';
  import AddressBook from '@/components/AddressBook/indexExpand';
  import {queryRoleList, queryRoleUserList, insertRoleUser, deleteByRoleIdAndUserId} from '@/api/dealerManage';

  export default {
    name: "platformRoleIndex",
    components: {
      AddressBook
    },
    data() {
      return {
        sexList: ['未知', '男', '女'],
        configData: {
          title: '选择用户范围',
          depart: {target: 'user', departType: 't', userTypes: '1'}
        },
        addressData: {},
        allRoleList: [],
        currentRole: null,
        constantId: null,
        dataList: []
      }
    },
    mixins: [windowResize],
    watch: {
      currentRole() {
        console.log(this.currentRole);
        this.queryRoleUserList();
        console.log(this.allRoleList.map(item => item.id).indexOf(Number(this.currentRole)));
        this.constantId = this.allRoleList[this.allRoleList.map(item => item.id).indexOf(Number(this.currentRole))].constantId
      },
      addressData(addressData) {
        if (addressData.departJson.length || addressData.userJson.length || addressData.groupJson.length) {
          const userList = addressData.userJson.map(item => item.id) || [];
          if (userList.length) {
            insertRoleUser({roleId: this.currentRole, userIds: userList.toString()}).then(data => {
              this.queryRoleUserList();
              this.$message.success('用户添加成功！');
              this.addressData = {};
            })
          } else {
            this.$message.error('请选择用户！');
          }
        } else {
          this.$message.error('请选择用户！');
        }
      }
    },
   activated() {
            this.queryRoleList();
        },
    created() {
      this.queryRoleList();
    },
    methods: {
        isShowByPermission,
      goBack() {
        this.$router.go(-1);
      },
      changeMenu(val) {
        this.currentRole = val;
      },
      queryRoleList() {
        queryRoleList().then(data => {
          this.allRoleList = data;
          this.currentRole = data[0].id.toString();
        })
      },
      queryRoleUserList() {
        queryRoleUserList({roleId: this.currentRole}).then(data => {
          this.dataList = data;
        })
      },
      deleteHandler(id) {
        this.$confirm("确认要移除当前用户吗？", "移除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        }).then(() => {
          deleteByRoleIdAndUserId({
            roleId: this.currentRole,
            userId: id
          }).then(() => {
            this.$message.success('移除成功');
            this.queryRoleUserList();
          })
        }).catch(err => {});
      }
    }
  }
</script>

<style>
  .plat_role_wrap .el-menu-item {
    height: 36px;
    line-height: 36px;
  }

  .plat_role_wrap .el-menu {
    border-right-width: 0;
  }
</style>
<style lang="scss" scoped>
  @import './../../../styles/mixin';

  .plat_role_wrap {
    height: 100%;
    padding: 12px;
    display: flex;
    box-sizing: border-box;

    .left_box {
      width: 180px;
      height: 100%;
      border-right: 1px solid #eee;
      overflow: hidden;

      .plat_role_title {
        height: 30px;
        line-height: 30px;
        padding-left: 20px;
        font-size: 20px;
        font-weight: bold;
      }

      .plat_role_box {
        @include scrollBar;
      }
    }

    .right_box {
      flex: 1;
      overflow: hidden;

      .header {
        height: 36px;
        padding-bottom: 10px;
        padding-left: 10px;
      }

      .plat_role_content {
        padding-left: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/dealerManage/platformRole/platformRoleIndex.vue